@if (downloading()) {
  <div class="external-placeholder">
    <div class="external-placeholder__wrapper">
      <div class="external-placeholder__text">Загружаем данные</div>
      <div class="external-placeholder__dot">...</div>
    </div>
  </div>
}
<ng-template #external/>
